module.exports = __webpack_public_path__ + "static/media/child-dataset-icon.c7e0cec9.svg";